// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__39KVZ","gfeWrapper":"CalendarEvent_gfeWrapper__1Zx9_"};